import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { array, func, string } from 'prop-types';
import CustomTable from '../../../../components/CustomTable/CustomTable';
import { OffersListItem } from '../../../../components/Offers/index';
import { FMessage } from '../../../../hoc/IntlComponents';

const propTypes = {
  offers: array.isRequired,
  onRequestOfferAccess: func,
  onFlowCreate: func.isRequired,
  sortOrder: string.isRequired,
  sortBy: string.isRequired,
};

const defaultProps = {
  offers: [],
  onRequestOfferAccess() {},
};

const OffersList = ({
  offers,
  offerSettings,
  removeOffer,
  onRequestOfferAccess,
  onFlowCreate,
  sortOrder,
  sortBy,
  handleSort,
  countries,
  currencies,
}) => (
  <CustomTable className="offers-list" responsive condensed aria-label="Offers">
    <CustomTable.Wrapper>
      <CustomTable.Row>
        <CustomTable.Cell />

        <CustomTable.Cell
          sortBy={sortBy}
          sortOrder={sortOrder}
          sortName="title"
          handleSort={handleSort}
          defaultSortOrder="asc"
          sorting
        >
          <FormattedMessage id="offers.table.offer.theme_4" defaultMessage="Offer" />
        </CustomTable.Cell>

        <CustomTable.Cell
          className="custom-hover-action"
          sortBy={sortBy}
          sortOrder={sortOrder}
          sortName="payout"
          handleSort={handleSort}
          defaultSortOrder="desc"
          sorting
        >
          <span className="offers-table-pixel-list-title">
            <span className="offers-table-pixel-list-title-item targets">
              <FormattedMessage id="offers.table.targets.theme_4" defaultMessage="Targets" />
            </span>
            <span className="offers-table-pixel-list-title-item payout">
              {/* <FormattedMessage id="offers.table.payout" defaultMessage="Payout" /> */}
            </span>
          </span>
        </CustomTable.Cell>

        <CustomTable.Cell className="offers-list-geo">
          <FormattedMessage id="offers.table.geo" defaultMessage="Geo" />
        </CustomTable.Cell>

        <CustomTable.Cell
          className="text-right"
          sortBy={sortBy}
          sortOrder={sortOrder}
          sortName="cr"
          handleSort={handleSort}
          defaultSortOrder="desc"
          sorting
        >
          CR
        </CustomTable.Cell>

        <CustomTable.Cell
          className="text-right"
          sortBy={sortBy}
          sortOrder={sortOrder}
          sortName="epc"
          handleSort={handleSort}
          defaultSortOrder="desc"
          sorting
        >
          EPC
        </CustomTable.Cell>
        <CustomTable.Cell
          className="text-right"
          sortBy={sortBy}
          sortOrder={sortOrder}
          sortName="rate"
          handleSort={handleSort}
          defaultSortOrder="desc"
          sorting
        >
          <FMessage id="offers.table.approve" />
        </CustomTable.Cell>

        <CustomTable.Cell className='text-center'>
          <FMessage id="offers.table.action" />
        </CustomTable.Cell>
      </CustomTable.Row>
    </CustomTable.Wrapper>

    {offers.length > 0 && (
      <CustomTable.Wrapper type="body">
        {offers.map(offer => (
          <OffersListItem
            removeOffer={removeOffer}
            key={offer.id}
            {...offer}
            onRequestOfferAccess={onRequestOfferAccess}
            onFlowCreate={onFlowCreate}
            offerSettings={offerSettings}
            countries={countries}
            globalCurrencies={currencies}
          />
        ))}
      </CustomTable.Wrapper>
    )}
  </CustomTable>
);

OffersList.propTypes = propTypes;
OffersList.defaultProps = defaultProps;

const mapStateToProps = state => ({
  offerSettings: state.app.settings.offer,
  countries: state.app.globalSettings.countries,
});

export default connect(mapStateToProps)(OffersList);
